import client from './client';

export const rolesApi = {
  getAll: () => client.get('/roles'),
  getById: (id) => client.get(`/roles/${id}`),
  create: (data) => client.post('/roles', data),
  update: (id, data) => client.put(`/roles/${id}`, data),
  delete: (id) => client.delete(`/roles/${id}`)
};
